import React from 'react'

// A quiet meter reading: an uppercase tertiary caption over a single tabular figure,
// with an optional supporting line beneath. Designed to sit in a hairline-divided
// strip (see AdminDashboard), so it carries no border of its own.
export type MetricTileProps = {
    label: React.ReactNode
    value?: React.ReactNode
    loading?: boolean
    hint?: React.ReactNode
}

export function MetricTile({ label, value, loading, hint }: MetricTileProps) {
    return (
        <div className="bg-white px-5 py-4">
            <div className="text-xs font-medium uppercase tracking-wide text-ink-tertiary">{label}</div>
            {loading ? (
                <div className="mt-2 h-6 w-16 animate-pulse rounded bg-hairline" />
            ) : (
                <div className="mt-1 text-2xl font-semibold tabular-nums leading-tight text-ink">{value ?? '—'}</div>
            )}
            {hint && <div className="mt-1 text-xs tabular-nums text-ink-tertiary">{hint}</div>}
        </div>
    )
}
